import {
  GET_VENDOR_DOWNLOADS_INFO,
  GET_VENDOR_DOWNLOADS_INFO_SUCCESS,
  GET_VENDOR_DOWNLOADS_INFO_ERROR,
  GET_VENDOR_DOWNLOADS_INFO_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadBookingsInfo = (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDOR_DOWNLOADS_INFO:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_DOWNLOADS_INFO_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_VENDOR_DOWNLOADS_INFO_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_VENDOR_DOWNLOADS_INFO_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadBookingsInfo;
